import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

export const DistanceSliderDropdown = ({ filters, setFilters, isOpen, onClose, inputRef }) => {
  const [localDistance, setLocalDistance] = useState(filters.minArea || 20);
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  // Berechne Position beim Öffnen
  useEffect(() => {
    if (isOpen && inputRef?.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
  }, [isOpen, inputRef]);

  // Aktualisiere lokalen State wenn Filter sich ändern
  useEffect(() => {
    setLocalDistance(filters.minArea || 20);
  }, [filters.minArea]);

  // Schließe beim Klick außerhalb
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (inputRef?.current && !inputRef.current.contains(event.target)) {
          onClose();
        }
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen, onClose, inputRef]);

  const handleDistanceChange = (values) => {
    setLocalDistance(values[1]); // Verwende den zweiten Wert (max) vom Range-Slider
  };

  const handleApply = () => {
    setFilters(prev => ({
      ...prev,
      minArea: localDistance
    }));
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div
      ref={dropdownRef}
      id="distance-slider-dropdown"
      className="fixed z-[9999] bg-white border border-gray-200 rounded-md shadow-lg p-4 w-[300px]"
      style={{
        top: `${dropdownPosition.top}px`,
        left: `${dropdownPosition.left}px`,
      }}
    >
      {/* Umkreis-Label */}
      <div className="mb-2">
        <p className="text-sm font-helvetica font-semibold text-primary">Umkreis</p>
      </div>

      {/* Slider */}
      <div className="mb-4">
        <RangeSlider
          value={[0, localDistance]}
          onInput={handleDistanceChange}
          min={1}
          max={100}
          step={1}
        />
      </div>

      {/* Entfernungs-Anzeige */}
      <div className="mb-4 text-center">
        <div className="text-lg font-helvetica font-medium text-primary">
          {localDistance} km
        </div>
      </div>

      {/* Aktionen */}
      <div className="flex gap-2">
        <button
          onClick={onClose}
          className="flex-1 px-3 py-2 text-sm font-helvetica border border-gray-300 rounded hover:bg-gray-50 transition-colors"
        >
          Abbrechen
        </button>
        <button
          onClick={handleApply}
          className="flex-1 px-3 py-2 text-sm font-helvetica bg-primary text-white rounded hover:bg-primary/90 transition-colors"
        >
          Übernehmen
        </button>
      </div>
    </div>,
    document.body
  );
};
